import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { AllocationType } from './types';

export const allocationTypesApi = createApi({
  reducerPath: 'allocationTypesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/allocation-types`,
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getAllocationTypes: builder.query<AllocationType[], void>({
      query: () => ({
        url: '',
      }),
    }),
  }),
});

export const { useGetAllocationTypesQuery } = allocationTypesApi;
